import { Button, Progress, notification } from 'antd';
import React from 'react';
import { CourseType } from '../../../types/course';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../../../types/user';
import { useTranslation } from 'react-i18next';
import { Enums } from '../../../shared';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';
import { isTeacher } from '../../../helpers/permissions';

const OpenCourseButton = ({ course }: { course: CourseType }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Button
            type="primary"
            style={{ width: '100%' }}
            onClick={() => navigate(`/app/courses/${course.id}`)}
        >
            {t('teacherDashboard.openCourseDetails')}
        </Button>
    );
};

const CourseEnrollButton = ({
    course,
    user,
}: {
    course: CourseType;
    user: UserType;
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [issueCommand, {}] = useIssueCommandMutation();

    const command = {
        type: Enums.COMMAND_TYPES.ENROLL_FOR_COURSE,
        userId: user.pk,
        courseId: course.id,
    };

    const handleEnroll = (command) => {
        issueCommand({
            command,
        })
            .unwrap()
            .then((res) => {
                notification.info({
                    message: t('enrolled'),
                    duration: 2,
                });
                navigate(`/app/courses/${course.id}`);
            })
            .catch((err) => {
                notification.error({
                    message: t('Ups! something went wrong!'),
                });
                console.error('Err: ', err);
            });
    };

    return (
        <Button onClick={() => handleEnroll(command)} style={{ width: '100%' }}>
            {t('enroll')}
        </Button>
    );
};

const getActions = (course: CourseType, user: UserType) => {
    if (course.is_enrolled) {
        return (
            <Progress
                style={{ width: '400px' }}
                data-cy="course-list-item-progress"
                percent={course.progress}
            />
        );
    } else if (isTeacher(user)) {
        // Teachers/admins are not enrolled in their own courses — give them a way
        // into the course detail (and its Students tab) instead of an enroll button.
        return <OpenCourseButton key={'open'} course={course} />;
    } else {
        return (
            <CourseEnrollButton key={'enroll'} course={course} user={user} />
        );
    }
};

export default getActions;
